// HEADERS
export const CHANNEL_HEADER = 'x-client-channel' // mobile or web
export const LOCALE_HEADER = 'x-market-locale' // fr_FR or es_ES
export const EMAIL_HIDDEN_HEADE = 'x-email-hidden' // SHA1
export const EMAIL_STRONG_HEADER = 'x-email-strong' // SHA256
export const EMAIL_STRONGER_HEADER = 'x-email-stronger' // HMAC-SHA256
export const CONSENT_VENDORS_HEADER = 'x-con-v'
export const CONSENT_STRING_HEADER = 'x-con-s'
export const CONSENT_ID_HEADER = 'x-con-id'
export const CONSENT_EXEMPT_ID_HEADER = 'x-con-ex'
export const ENV_HEADER = 'x-api-env'
export const CLIENT_APP_ID_HEADER = 'x-client-app-id' // front-web
export const DEVICE_OS_VERSION_HEADER = 'x-device-os-version' // Android Samsung xv25
export const DEVICE_CLASS_HEADER = 'x-device-class' // [smartphone|tablet]
export const APP_VERSION_HEADER = 'x-app-version' // [ARTIFACT_ID]
export const BFF_KEY_HEADER = 'x-bff-key'
export const NAVIGATION_PREVIOUS_HEADER = 'x-nav-previous-page'
export const NAVIGATION_CURRENT_HEADER = 'x-nav-current-path'
export const NAVIGATION_PAGE_PARAMS = 'x-nav-page-params'
export const NAVIGATION_SESSION = 'x-nav-session-id'
export const NAVIGATION_SESSION_INIT = 'session-init'
export const VISITOR_TYPE_HEADER = 'x-visitor-type'
export const EVENTS_PUSH_HEADER = 'x-events-push'
export const EVENTS_CLICK_HEADER = 'x-events-click'
export const TRACE_ID_HEADER = 'x-trace-id'
export const ATTRIBUTION_REFERRER_HEADER = 'x-attribution-referrer'
export const ATTRIBUTION_CLID_HEADER = 'x-attribution-clid'
export const ATTRIBUTION_CRM_HEADER = 'x-attribution-crm'
export const ATTRIBUTION_GCLID_HEADER = 'x-attribution-gclid'
export const ATTRIBUTION_FBCLID_HEADER = 'x-attribution-fbclid'
export const ATTRIBUTION_PREX_HEADER = 'x-attribution-prex'
export const FLAGSHIP_HEADER = 'x-flagship'
export const CRITEO_ID_HEADER = 'x-criteo-id'
export const VIRTUAL_ENV_NAME = 'virtual-env-name'
export const SEARCH_USAGE_HEADER = 'x-search-usage'
export const ABTASTY_HEADER = 'x-abtest-ids'
export const ATTRIBUTION_SCCID_HEADER = 'x-attribution-sccid'
export const ATTRIBUTION_TTCLID_HEADER = 'x-attribution-ttclid'
export const ATTRIBUTION_EAD_NAME_HEADER = 'x-attribution-ead-name'

// QUERY PARAMS
export const WIZ_MEDIUM = 'wiz_medium'
export const WIZ_SOURCE = 'wiz_source'
export const WIZ_COMPAIGN = 'wiz_campaign'
export const WIZ_TERM = 'wiz_term'
export const WIZ_CONTENT = 'wiz_content'
export const WIZ_CLID = 'wiz_clid'
export const WIZ_CRM = 'wiz_crm'
export const GCLID = 'gclid'
export const FACEBOOK_CLID = 'fbclid'
export const PREX = 'prex'
export const POST_BACK_ID = 'postbackid'
export const TD_UID = 'tduid'
export const EFF_UID = 'eff_uid'
export const LIL_CLID = 'lil_clid'
export const SNAPCHAT_CID = 'ScCid'
export const TIKTOK_CLID = 'ttclid'
// Eulerian
export const ATTRIBUTION_ESL_K = 'esl-k'
export const ATTRIBUTION_ESEG_NAME = 'eseg-name'
export const ATTRIBUTION_ESEG_ITEM = 'eseg-item'
export const ATTRIBUTION_EAD_PUBLISHER = 'ead-publisher'
export const ATTRIBUTION_EAD_NAME = 'ead-name'
export const ATTRIBUTION_EAD_LOCATION = 'ead-location'
export const ATTRIBUTION_EAD_CREATIVE = 'ead-creative'
export const ATTRIBUTION_EAD_CREATIVETYPE = 'ead-creativetype'
export const ATTRIBUTION_EAD_MEDIAPLAN = 'ead-mediaplan'
export const ATTRIBUTION_ESC_PUBLISHER = 'esc-publisher'
export const ATTRIBUTION_ESC_NAME = 'esc-name'
export const ATTRIBUTION_ESC_LOCATION = 'esc-location'
export const ATTRIBUTION_ESC_CREATIVE = 'esc-creative'
export const ATTRIBUTION_ESC_CREATIVETYPE = 'esc-creativetype'
export const ATTRIBUTION_ESC_MEDIAPLAN = 'esc-mediaplan'
export const ATTRIBUTION_EAF_PUBLISHER = 'eaf-publisher'
export const ATTRIBUTION_EAF_NAME = 'eaf-name'
export const ATTRIBUTION_EAF_LOCATION = 'eaf-location'
export const ATTRIBUTION_EAF_CREATIVE = 'eaf-creative'
export const ATTRIBUTION_EAF_CREATIVETYPE = 'eaf-creativetype'
export const ATTRIBUTION_EAF_MEDIAPLAN = 'eaf-mediaplan'
export const ATTRIBUTION_EML_PUBLISHER = 'eml-publisher'
export const ATTRIBUTION_EML_NAME = 'eml-name'
export const ATTRIBUTION_EML_MEDIAPLAN = 'eml-mediaplan'
export const ATTRIBUTION_UID = 'uid'
export const ATTRIBUTION_EEMAIL = 'eemail'
export const ATTRIBUTION_EPT_PUBLISHER = 'ept-publisher'
export const ATTRIBUTION_EPT_NAME = 'ept-name'
export const ATTRIBUTION_EPT_MEDIAPLAN = 'ept-mediaplan'
export const ATTRIBUTION_ETF_PUBLISHER = 'etf-publisher'
export const ATTRIBUTION_ETF_NAME = 'etf-name'
export const ATTRIBUTION_ETF_PRDREF = 'etf-prdref'
export const ATTRIBUTION_ETF_MEDIAPLAN = 'etf-mediaplan'
export const ATTRIBUTION_ETF_MEDIA = 'etf-media'
export const ATTRIBUTION_EGN_PUBLISHER = 'egn-publisher'
export const ATTRIBUTION_EGN_NAME = 'egn-name'
export const ATTRIBUTION_EGN_MEDIAPLAN = 'egn-mediaplan'
export const ATTRIBUTION_EA_RND = 'ea-rnd'
export const ATTRIBUTION_GDPR = 'gdpr'
export const ATTRIBUTION_GDPR_CONSENT = 'gdpr_consent'
export const ATTRIBUTION_PMCATEGORY = 'pmcat'
export const ATTRIBUTION_GDPR_PD = 'gdpr_pd'
export const ATTRIBUTION_ACCOR_CLID = 'accor_clid'
export const ATTRIBUTION_KYKID = 'kykid'
export const ATTRIBUTION_AD_MARKET_PLACE = 'admarketplaceid'
